import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import FormDeleteUser from "./FormDeleteUser";
import "../../../components/jds/jds.css";
import "../clienteDados.css";

export function ConfirmDeleteModal({ id, show, onHide }) {
  // Customers Redux state
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);

  // if !id we should close modal
  React.useEffect(() => {
    if (!id && show) {
      onHide();
    }
  }, [id, show, onHide]);

  const deleteCustomer = (reason) => {
    setIsLoading(true);

    // server request for deleting customer by id
    dispatch({
      type: "ADMIN_DELETE_USER",
      payload: {
        id,
        reason
      }
    });

    setTimeout(() => {
      window.location.href = "/clientes";
    }, 3000);
  };


  return (
    <Modal
      show={show}
      onHide={onHide}
      className="jds-scope"
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {isLoading && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Tem certeza que deseja desativar este cliente? 
          
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <>
            <span>Essa ação não apaga os dados permanentemente, apenas muda o status do cliente para “Desativado”.</span>
            <hr className="jds-divider" />
            <FormDeleteUser onSubmitForm={deleteCustomer} onCancel={onHide} />
          </>
        )}
        {isLoading && <span>Deletando usuário...</span>}
      </Modal.Body>
    </Modal>
  );
}
